function getPreviewState(state) {
  return {
    postingData: state.preview.postingData,
    errorPostingData: state.preview.errorPostingData,
    loadingPostingData: state.preview.loadingPostingData,
    getPostingDataComplete: state.preview.getPostingDataComplete,
    qualityData: state.preview.qualityData,
    loadingQualityData: state.preview.loadingQualityData,
    errorQualityData: state.preview.errorQualityData
  };
}

export { getPreviewState };
